import * as Flags from 'country-flag-icons/react/3x2';
import React from 'react';

import { css } from 'config/emotionCss';
import colors from 'config/theme/colors';

const flagStyle = css`
  border: 1px solid ${colors['@border-color-split']};
  border-radius: 2px;
`;

type FlagProps = {
  countryCode: keyof typeof Flags;
  className?: string;
};

const Flag: React.FC<FlagProps> = ({ countryCode, className = '' }) => {
  const FlagComponent = Flags[countryCode];

  return FlagComponent && <FlagComponent className={`${flagStyle} ${className}`} />;
};

export default Flag;
